<template>
    <div class="maintenance-page">
        <h1>{{ $t("weihu1") }}</h1>
        <p>{{ $t("weihu2") }}</p>
    </div>
  </template>
  
<script>
import instance from '@/util/axios.js';

export default {
  name: 'MaintainComponent',
  mounted() {
    // 在组件挂载时调用 getToken() 函数来获取 CSRF Token
    this.getToken();
  },
  methods: {
    getToken() {
      instance.get("/api/v1/userweb/get_csrf_token")
      .then(response => {
          if (response.data.status == 0) {
            this.$router.push("/login");
          }
      })
    }
  }
}

</script>

  <style>
  .maintenance-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    font-family: Arial, sans-serif;
    background-color: #f0f0f0;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 16px;
    color: #555;
  }
  </style>